import * as ActionTypes from './action-types';

export const setCountries = countries => ({
  type: ActionTypes.SET_COUNTRIES,
  payload: [...countries],
});
